import {MathHelper} from "../../../../core/utils/MathHelper";
import {PunkRocker} from "../../../PunkRocker";
import {NormalStartPresentation} from "./NormalStartPresentation";
import {InitData} from "../../../server/data/InitData";
import {jumpingWildConfig} from "../../../server/base/IData";
import {TrainState} from "../../independent/trains/TrainState";
import {SoundManager} from "../../../sound/SoundManager";
import {PRGameMode} from "../../../server/PRGameMode";
import {PREngineManager} from "../../../punkEngine/PREngineManager";


export class FSStartPresentation extends NormalStartPresentation {

    /*private playRestore: boolean = false;
    private _nextMode: string;*/

    public setInitData(data: InitData) {
        /*this.playRestore = data.isRestoreState;
        this._nextMode = data.nextMode;*/
        // for(let s:number = 0; s < data.Reel.scatterPositions.length; s++) if(data.Reel.scatterPositions[s] >= 0)  this.restored  = false;
    }

    createPresentation() {
        SoundManager.reset();
        if (this.gameData.isRestoreState) {
            PunkRocker.jumpWilds.ChangeToSpine(true);
            PunkRocker.keypadPlugin.setWin(this.gameData.raw.accumulatedRoundWin, true, this.gameData.Win.isWinBelowStake());
            const jwList: jumpingWildConfig[] = this.gameData.raw.jumpingWildList;
            for (let i: number = 0; i < jwList.length; i++) {
                const currJW: jumpingWildConfig = jwList[i],
                    currJWReelId: number = currJW.newCoord.x,
                    currJWSymId: number = currJW.newCoord.y;

                if (currJWReelId !== -1 && currJWSymId !== -1) {
                    PunkRocker.jumpWilds.startShowJW(i, currJWReelId, currJWSymId, false, true);
                }
            }
        }

        this.startReels();
        this.removeTrain();
        this.PresentationState.setInactive();
    }

    skip(): void {
        // RoadRageEngineManager.isQuickStop = true;
    }

    done(): void {
    }

    protected removeTrain(): void {
        let durr = 0;

        this.timeline.add(() => {
            PunkRocker.trainsManager.topTrain.showGlowPositions([0, 1, 2, 3, 4, 5], false, 0.3);
            PunkRocker.trainsManager.bottomTrain.showGlowPositions([0, 1, 2, 3, 4, 5], false, 0.3);
        });

        this.timeline.add(() => {
            PunkRocker.trainsManager.topTrain.showTrainItems(false, [], 0.3);
            PunkRocker.trainsManager.bottomTrain.showTrainItems(false, [], 0.3);
        }, durr);

        durr += MathHelper.frameToSeconds(10);

        this.timeline.add(() => {
            PunkRocker.trainsManager.topTrain.setTrainState(TrainState.TRAIN_CLOSE_EXIT);
            const isUpgrade: boolean = (this.gameData.raw.nextMode === PRGameMode.FREESPIN_LEVEL_TWO || this.gameData.raw.nextMode === PRGameMode.FREESPIN_LEVEL_THREE);
            PunkRocker.trainsManager.bottomTrain.setTrainState(TrainState.TRAIN_CLOSE_EXIT, isUpgrade);
        }, durr);

        this.timeline.add(() => {
            PunkRocker.waysCounter.FreeSpinsCounter(1.5, true);
        }, durr - 0.3);//"-=0.5");

        this.timeline.to(this, {
            duration: PunkRocker.trainsManager.getMaxDuration(TrainState.TRAIN_CLOSE_EXIT)
        }, durr);
    }

    private getTopPositionedJw(reelIdToCheck: number): number {
        const jwList: jumpingWildConfig[] = this.gameData.raw.jumpingWildList,
            jwOnUpgradeReel: number[] = [],
            jwArray: jumpingWildConfig[] = [];

        for (let i: number = 0; i < jwList.length; i++) {
            const currJW: jumpingWildConfig = jwList[i];

            if (currJW.reelChosen === reelIdToCheck) {
                jwOnUpgradeReel.push(i);
            }
        }

        if (jwOnUpgradeReel.length > 0) {
            for (let i: number = 0; i < jwOnUpgradeReel.length; i++) {
                jwArray.push(jwList[jwOnUpgradeReel[i]]);
            }
        }

        const lowestItem: number = jwArray.reduce((minItem, currentItem, currentIndex, arr) => {
            if (currentItem.newCoord.y < arr[minItem].newCoord.y) {
                return currentIndex;
            } else {
                return minItem;
            }
        }, 0);

        return jwOnUpgradeReel[lowestItem];
    }
}